export enum ProductionCardRoles {
  ProductionCardsViewer = 'ProductionCardsViewer',
  ProductionCardsEditor = 'ProductionCardsEditor',
  ProductionMainViewer = 'ProductionMainViewer',
  ProductionCardsCloser = 'ProductionCardsCloser',
  BatchingGreigeTransferAdmin = 'BatchingGreigeTransferAdmin',
  ProductionCardPlanningStatusEditor = 'ProductionCardPlanningStatusEditor',
  ProductionCardGreigeStatusEditor = 'ProductionCardGreigeStatusEditor',
  ProductionCardBatchingStatusEditor = 'ProductionCardBatchingStatusEditor',
  ProductionCardDyeingStatusEditor = 'ProductionCardDyeingStatusEditor',
  ProductionCardFinishingStatusEditor = 'ProductionCardFinishingStatusEditor',
}

export enum ProductionWorkOrderRoles {
  ProductionWorkOrderViewer = 'ProductionWorkOrderViewer',
  ProductionWorkOrderEditor = 'ProductionWorkOrderEditor',
}

export enum ProductionBatchRoles {
  ProductionBatchViewer = 'ProductionBatchViewer',
  ProductionBatchEditor = 'ProductionBatchEditor',
}

export enum KnittingOrderRoles {
  KnittingOrderViewer = 'KnittingOrderViewer',
  KnittingOrderAllEditor = 'KnittingOrderAllEditor',
}

export enum MachineDashboardRoles {
  MachineDashboardViewer = 'MachineDashboardViewer',
  MachineDashboardEditor = 'MachineDashboardEditor',
}

export enum MachineAssignmentRoles {
  MachineAssignmentViewer = 'MachineAssignmentViewer',
  MachineAssignmentAdmin = 'MachineAssignmentAdmin',
}
export enum StationsRoles {
  WeightStationsViewer = 'WeightStationsViewer',
  WeightStationsEditor = 'WeightStationsEditor',
}

export enum ReprocessOrdersRoles {
  ReprocessOrdersAdmin = 'ReprocessOrdersAdmin',
}

export enum DyeingRoles {
  DyeingViewer = 'DyeingViewer',
  DyeingAdmin = 'DyeingAdmin',
  DyeingQualityAdmin = 'DyeingQualityAdmin',
}

export enum FinishingRoles {
  FinishingViewer = 'FinishingViewer',
  FinishingAdmin = 'FinishingAdmin',
  FinishingRouteRollingAdmin = 'FinishingRouteRollingAdmin',
  FinishingRouteReorganizeAdmin = 'FinishingRouteReorganizeAdmin',
  ChangeUOMCuadraje = 'ChangeUOMCuadraje',
  ProductionCardBalancingProportionViewer = 'ProductionCardBalancingProportionViewer',
}

export enum BatchingRoles {
  BatchingViewer = 'BatchingViewer',
  BatchingAdmin = 'BatchingAdmin',
}

export enum PlanningDashboardRoles {
  PlanningDashboardViewer = 'PlanningDashboardViewer',
  PlanningDashboardAdmin = 'PlanningDashboardAdmin',
}

export enum ShiftsRoles {
  ShiftsViewer = 'ShiftsViewer',
  ShiftsAdmin = 'ShiftsAdmin',
}

export enum ProductionDashboardRoles {
  ProductionDashboardViewer = 'ProductionDashboardViewer',
  ProductionDashboardAdmin = 'ProductionDashboardAdmin',
}

export enum DyehouseDailyMetricRoles {
  DyehouseDailyMetricViewer = 'DyehouseDailyMetricViewer',
  DyehouseDailyMetricAdmin = 'DyehouseDailyMetricAdmin',
}

export enum ProductionReportsRoles {
  ProductionReportsViewer = 'ProductionReportsViewer',
  ProductionReportsAdmin = 'ProductionReportsAdmin',
}

export enum DyeingCycleConsumptionRoles {
  DyeingCycleConsumptionViewer = 'DyeingCycleConsumptionViewer',
  DyeingCycleConsumptionAdmin = 'DyeingCycleConsumptionAdmin',
}

export enum FinishingRouteConsumptionRoles {
  FinishingRouteConsumptionAdmin = 'FinishingRouteConsumptionAdmin',
}

export enum DailyProductionProcessRoles {
  DailyProductionKnittingViewer = 'DailyProductionKnittingViewer',
  DailyProductionGreigeViewer = 'DailyProductionGreigeViewer',
  DailyProductionBatchingViewer = 'DailyProductionBatchingViewer',
  DailyProductionDyeingViewer = 'DailyProductionDyeingViewer',
  DailyProductionFinishingViewer = 'DailyProductionFinishingViewer',
  DailyProductionRollingViewer = 'DailyProductionRollingViewer',
  DailyProductionFinishedGoodsViewer = 'DailyProductionFinishedGoodsViewer',
}

/** Per-area access to the Area Production Detail report. Only Knitting is provisioned for the initial release. */
export enum ProductionDetailProcessRoles {
  ProductionDetailKnittingViewer = 'ProductionDetailKnittingViewer',
  ProductionDetailDyeingViewer = 'ProductionDetailDyeingViewer',
  ProductionDetailFinishingViewer = 'ProductionDetailFinishingViewer',
}
